// extracted by mini-css-extract-plugin
module.exports = {"ServiceGrid":"ServiceGrid_ServiceGrid__8ZhBi","grid":"ServiceGrid_grid__9UblZ","images":"ServiceGrid_images__IwYge","inModal":"ServiceGrid_inModal__xuCwt"};